import React from 'react'

import {
  AlignItems,
  Body1,
  Body2,
  BorderStyle,
  Box,
  Button,
  ButtonColorVariant,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Icon,
  IconVariant,
  JustifyContent,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { EditDeliveryDayRow } from './EditDeliveryDayRow'

export type ExpandedProps = {
  boxSize: string
  deliveryDay: string
  address: string
  onEditBoxSize: () => void
  onEditAddress: () => void
  onRowConfirmed: () => void
  onClose: () => void
}

type RowProps = {
  label: string
  value: string
  buttonLabel: string
  onEdit: () => void
}

const Row = ({ label, value, buttonLabel, onEdit }: RowProps) => (
  <Box
    display={Display.Flex}
    alignItems={AlignItems.Center}
    justifyContent={JustifyContent.SpaceBetween}
    gap={3}
  >
    <Box
      display={Display.Flex}
      flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
      alignItems={[AlignItems.FlexStart, null, AlignItems.Baseline]}
      gap={[1, null, 4]}
      flexGrow={1}
    >
      <Box width={['auto', null, '168px']} flexShrink={0}>
        <Body1 size={[2, null, 6]} color={Color.ColdGrey_600}>
          {label}
        </Body1>
      </Box>
      <Body1 size={[2, null, 6]} fontWeight={FontWeight.Bold} color={Color.ColdGrey_800}>
        {value}
      </Body1>
    </Box>
    <Button
      colorVariant={ButtonColorVariant.Tertiary}
      onClick={onEdit}
      aria-label={buttonLabel}
      style={{ padding: 0 }}
    >
      Edit
    </Button>
  </Box>
)

export const Expanded = ({
  boxSize,
  deliveryDay,
  address,
  onEditBoxSize,
  onEditAddress,
  onRowConfirmed,
  onClose,
}: ExpandedProps) => (
  <Box
    bg={Color.White}
    borderStyle={BorderStyle.Solid}
    borderColor={Color.ColdGrey_100}
    borderBottomWidth={0.5}
  >
    <Box
      maxWidth="1600px"
      paddingV={3}
      paddingH={[4, null, 8]}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      gap={4}
      style={{ margin: '0 auto' }}
    >
      <EditDeliveryDayRow currentDayLabel={deliveryDay} onConfirmComplete={onRowConfirmed} />
      <Row label="Box size" value={boxSize} buttonLabel="Edit box size" onEdit={onEditBoxSize} />
      <Row
        label="Delivery address"
        value={address}
        buttonLabel="Edit delivery address"
        onEdit={onEditAddress}
      />
      <Body2 size={[0, null, 4]} color={Color.ColdGrey_600} textAlign={TextAlign.Center}>
        We&rsquo;ve based your box size and address on your preferences
      </Body2>
      {/* Native button, not Citrus's <Button> — Figma has this flush against the 24px icon
          with no padding, which Citrus's Button can't produce (it always adds its own). */}
      <button
        type="button"
        onClick={onClose}
        aria-label="Collapse delivery settings"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          padding: 0,
          border: 'none',
          background: 'none',
          cursor: 'pointer',
        }}
      >
        <Icon name="chevron_up" size={6} variant={IconVariant.Actionable} />
      </button>
    </Box>
  </Box>
)
